<template>
  <div class="page_content">

    <div class="row page-heading">
      <div class="col-7 input module_heading" role="heading" aria-level="1">
        <div class="module_icon ic22-dateRange"></div>
        <label class="head_txt module_type_name">{{ event.title }}</label>
      </div>
      <div class="col-5 float-right px-0">
        <div class="btn-container">
          <button @click="goToEditPage" class="btn" disabled aria-label="edit">Edit</button>
        </div>
      </div>
    </div>
    <div class="row column-2">
      <div class="thumbnail_panel">
        <div class="thumbnail_container d-flex" tabindex="0">
          <div class="default">
            <div class="thumbnail">
              <div class="thumbnail_icon fas fa-calendar-alt"></div>
            </div>
          </div>
        </div>
        <div class="content-row">
          <label class="heading" tabindex="0">Folder</label>
          <div class="result-value" tabindex="0">{{ eventLibraryName }}</div>
        </div>
        <div class="content-row" v-if="event.ownerName">
          <label class="heading" tabindex="0">Created By</label>
          <div class="result-value" tabindex="0">{{ event.ownerName }}</div>
        </div>
      </div>
      <div class="page-section">
        <div class="page_section_row" v-if="event.description">
          <div class="heading"><label tabindex="0">Event Description</label></div>
          <div class="page_content_block">
            <div v-html="event.description" tabindex="0"></div>
          </div>
          <a href="javascript:void(0)" class="more-btn more-desc float-right mt-1" @click="showAll" aria-label="read more">more</a>
          <b-modal id="eventDesc" class="custom_modal course_description" size="lg" centered hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="popup-heading">Event Description</div>
              <button class="btn_close" aria-label="close" @click="closeshowAll">
                <span class="ic-close"></span>
              </button>
            </div>
            <div class="catalog-desc-content" v-html="event.description"></div>
          </b-modal>
        </div>
        <!-- skills -->
        <div class="page_section_row" v-if="skills && skills.length > 0">
          <div class="heading"><label for="eventSkillTags">Skills</label></div>
          <div id="eventSkillTags" class="page_content_block">
            <div class="tag-section">
              <div class="tag-container">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="tags-row tags_container">
                  <span class="tag" v-for="tag in skills" :title="tag.name" :aria-label="tag.name">
                    <span class="tag_name competency_tag ace_sec_txt"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- tags -->
        <div class="page_section_row" v-if="tags && tags.length > 0">
          <div class="heading"><label for="eventTags">Tags</label></div>
          <div id="eventTags" class="page_content_block">
            <div class="tag-section">
              <div class="tag-container">
                <div class="icon-container">
                  <span class="icon ic-tag"></span>
                </div>
                <div class="tags-row tags_container">
                  <span class="tag" v-for="tag in tags" :title="tag.name" :aria-label="tag.name">
                    <span class="tag_name instructional_tag ace_sec_txt"> {{ tag.name }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_section_row" v-if="event.address">
          <div class="heading"><label tabindex="0">Address</label></div>
          <div class="page_content_block">
            <div tabindex="0">{{ event.address }}</div>
          </div>
        </div>
        <div class="page_section_row" v-if="eventHasInformation">
          <div class="heading"><label tabindex="0">Event Information</label></div>
          <div class="page_content_block">
            <div>
              <span class="start-time" v-if="event.start_date || event.start_time" tabindex="0">{{changeDateFormat(event.start_date) }}, {{event.start_time }}</span>
              <span class="end-time" v-if="event.end_date || event.end_time" tabindex="0">to {{ changeDateFormat(event.end_date)}}, {{ event.end_time}}</span>
            </div>
          </div>
        </div>
        <div class="page_section_row" >
          <div class="heading"><label tabindex="0">Organizer Name</label></div>
          <div class="page_content_block">
            <div id="eventOrganizerName" v-if="event.organizer_name" tabindex="0">{{ event.organizer_name }}</div>
          </div>
        </div>
        <div class="page_section_row" >
          <div class="heading"><label tabindex="0">Organizer Email</label></div>
          <div class="page_content_block">
            <div v-if="event.organizer_email" tabindex="0">{{ event.organizer_email }}</div>
          </div>
        </div>
        <div class="page_section_row" >
          <div class="heading"><label tabindex="0">Organizer Phone</label></div>
          <div class="page_content_block">
            <div v-if="event.organizer_phone_number" tabindex="0">{{ event.organizer_phone_number }}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'event-detail',
  props: ['uuid'],
  data: () => {
    return {
      tags: [],
      skills: [],
      userId: {},
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }
  },
  mounted () {
    this.loadDataForEventDetail()
  },
  methods: {
    ...mapActions([
      'loadEvent',
      'loadLibrariesForUser'
    ]),
    showAll () {
      this.$root.$emit('bv::show::modal', 'eventDesc')
    },
    closeshowAll () {
      this.$root.$emit('bv::hide::modal', 'eventDesc')
    },
    goToEditPage () {
      this.$router.push({name: 'editEvent', params: {uuid: this.uuid}})
    },
    async loadDataForEventDetail () {
      await this.loadEvent({ uuid: this.uuid, loadDataFromServer: true })
      this.userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(this.userId)
      this.populateSkillsAndTags(this.event)
    },
    populateSkillsAndTags (entity) {
      let appliedTagMap = entity.appliedTagMap
      if (appliedTagMap) {
        let tagEntries = Object.entries(appliedTagMap)
        if (tagEntries && tagEntries.length > 0) {
          for (const [key, values] of tagEntries) {
            if (key) {
              values.forEach(value => {
                this.tags.push(value)
              })
            }
          }
        }
      }
      let careerCompetenciesMap = entity.careerCompetenciesMap
      if (careerCompetenciesMap) {
        let skillEntries = Object.entries(careerCompetenciesMap)
        if (skillEntries && skillEntries.length > 0) {
          for (const [key, values] of skillEntries) {
            if (key) {
              values.forEach(value => {
                this.skills.push(value)
              })
            }
          }
        } else {
          this.skills = entity.careerCompetenciesList
        }
      } else {
        this.skills = entity.careerCompetenciesList
      }
    },
    changeDateFormat (eventDate) {
      let dateParts = eventDate.split('/')
      let modifiedDate = (dateParts.length > 2) ? dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1] : eventDate
      let d = new Date(modifiedDate)
      let ret = String(this.days[d.getDay()]).slice(0, 3)
      ret += ', ' + String(this.months[d.getMonth()]).slice(0, 3)
      ret += ' ' + d.getDate()
      ret += ', ' + d.getFullYear()
      return ret
    }
  },
  computed: {
    ...mapState({
      'event': state => state.event.eventObject,
      'learningSpaces': state => state.assessment.learningSpaces,
      'ownerId': state => state.event.eventObject.ownerId,
      'owningLibraryId': state => state.event.eventObject.owningLibraryId
    }),
    'eventLibraryName': function () {
      let libName = ''
      let owningLibraryId = this.owningLibraryId
      this.learningSpaces.forEach(function (lib) {
        if (owningLibraryId === lib.uuid) {
          libName = lib.displayName
        }
      })
      return libName
    },
    'eventHasInformation': function () {
      if (this.event.start_time || this.event.start_date ||
        this.event.end_time || this.event.end_date) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.label {
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/app/event/components/EventDetail.vue